import { useEffect } from "react";
import { LATEST_CHANGE_DATE, changelogStatus } from "./changelog.ts";
import { useStore } from "./store.ts";

/** True when the changelog has an entry this player hasn't looked at. Brand-new players are quietly caught up instead. */
export function useNewChanges(): boolean {
  const seen = useStore((s) => s.changelogSeen);
  const hasHistory = useStore((s) => s.seenIntro || s.sent.length > 0 || Object.keys(s.stars).length > 0 || Object.keys(s.received).length > 0);
  const markSeen = useStore((s) => s.markChangelogSeen);
  const status = changelogStatus({ seen, latest: LATEST_CHANGE_DATE, hasHistory });
  useEffect(() => {
    if (status === "first-visit") markSeen(LATEST_CHANGE_DATE);
  }, [status, markSeen]);
  return status === "new";
}
